import type { BattleEngine } from '../../engine/engine';
import type { BattleCommand, CardId, CommandResult, PlayerId, WorldPoint } from '../../engine/types';
import type { BattleDriver } from './battle-driver';

export class ReplayDriver implements BattleDriver {
  readonly kind = 'replay' as const;
  readonly allowsPause = true;
  readonly allowsInput = false;
  private index = 0;

  constructor(private readonly commands: readonly BattleCommand[], readonly localSide: PlayerId) {}

  beforeStep(engine: BattleEngine): void {
    while (this.index < this.commands.length && this.commands[this.index]!.tick <= engine.currentTick) engine.enqueue(this.commands[this.index++]!);
  }

  afterStep(): void {}

  canAdvance(): boolean { return true; }

  submitCard(): CommandResult { return { ok: false, reason: 'invalid-command' }; }
  dispose(): void {}
}
